import fancybox from '@fancyapps/fancybox';

jQuery(document).ready(function ($) {
    $().fancybox({
        selector: '.product__fancybox'
    });

    $('.product__image-slide-inner').hover(
            function () {
                $('.product__image-zoom').addClass('product__image-zoom--hover');
            }, function () {
                $('.product__image-zoom').removeClass('product__image-zoom--hover');
            }
    );

});
